import { EapSettingsCreateModel } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.model';
import { EapSettingsFormProtocolModel } from './eap-settings-form-protocol.model';

export const mapEapSettingsToFormProtocol = (eapSettings: EapSettingsCreateModel): EapSettingsFormProtocolModel => ({
    anonymousUser: eapSettings?.anonymousUser,
    caCertificateFilename: eapSettings?.caCertificateFilename,
    clientCertificateFilename: eapSettings?.clientCertificateFilename,
    clientPrivateKeyFilename: eapSettings?.clientPrivateKeyFilename,
    eapType: eapSettings?.eapType || 'PEAP',
    password: eapSettings?.password,
    username: eapSettings?.username,
    confirmPassword: eapSettings?.confirmPassword,
    caCertificate: eapSettings?.caCertificate,
    clientCertificate: eapSettings?.clientCertificate,
    clientPrivateKey: eapSettings?.clientPrivateKey,
    assignedDeviceCount: eapSettings?.assignedDeviceCount || 0,
});
